import { getBaseURL } from "@/helpers/Host";
import axios from 'axios';

export default class Api {
    constructor() {
        this.initialize();
    }

    setToken(token) {
        if (!this.api) return;
        this.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    async initialize() {
        const token = localStorage.getItem('token');

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        this.api = axios.create({
            baseURL: await getBaseURL(),
            headers: headers
        });

        this.api.interceptors.request.use(config => {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        });
    }

    async getDataApi(route, data = {}) {
        try {
            const response = await this.api.get(route, { data });

            return {
                status: true,
                message: response.data.message,
                data: response.data.data || null
            };
        } catch (error) {
            return {
                status: false,
                message: error.response?.data?.message || 'Erro inesperado.',
                errors: error.response?.data?.data?.errors || null
            };
        }
    }

    async postDataApi(route, data = {}) {
        try {
            const isFormData = data instanceof FormData;

            const response = await this.api.post(route, data, {
                headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {}
            });

            return {
                status: true,
                message: response.data.message,
                data: response.data.data || null
            };
        } catch (error) {
            return {
                status: false,
                message: error.response?.data?.message || 'Erro inesperado.',
                errors: error.response?.data?.data?.errors || null
            };
        }
    }

    async putDataApi(route, data = {}) {
        try {
            const response = await this.api.put(route, data);

            return {
                status: true,
                message: response.data.message,
                data: response.data.data || null
            };
        } catch (error) {
            return {
                status: false,
                message: error.response?.data?.message || 'Erro inesperado.',
                errors: error.response?.data?.data?.errors || null
            };
        }
    }

    async deleteDataApi(route, data = {}) {
        try {
            const response = await this.api.delete(route, { data });

            return {
                status: true,
                message: response.data.message,
                data: response.data.data || null
            };
        } catch (error) {
            return {
                status: false,
                message: error.response?.data?.message || 'Erro inesperado.',
                errors: error.response?.data?.data?.errors || null
            };
        }
    }
}